import { http, type Transport } from 'viem'

import { traceRpcFetchInit } from '../../utils/debugRpcTraffic'
import type { ChainDefinition } from '../types'

import { getRpcUrlForChain } from './getRpcUrl'

function buildInstrumentedHttpTransport(url: string, stack: string, chainId: number): Transport {
  return http(url, {
    onFetchRequest(_request, init) {
      traceRpcFetchInit(init, stack, chainId)
    },
  })
}

/** Mapa `chainId → transport` para wagmi (lecturas públicas instrumentadas). */
export function buildWagmiTransports(chains: ChainDefinition[]): Record<number, Transport> {
  const transports: Record<number, Transport> = {}
  for (const chain of chains) {
    if (!chain.configured) continue
    const url = getRpcUrlForChain(chain)
    transports[chain.chainId] = buildInstrumentedHttpTransport(url, `wagmi:${chain.chainId}`, chain.chainId)
  }
  return transports
}
